var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{style:(_vm.fontStyle),attrs:{"href":_vm.href,"target":_vm.target},on:{"mouseenter":function($event){return _vm.enter()},"mouseleave":function($event){return _vm.leave()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }